<template>
    <div
        ref="expressionWrapper"
        v-bind:class="showClassObj">
        <pc-interact
            class="d-flex"
            v-bind:is-draggable="true"
            v-on:drag-move="dragMove"
            v-on:drag-end="dragEnd"
            v-on:initial-move="displayClone">
            <div
                v-bind:class="classObject"
                class="m-1 d-inline-flex text-nowrap formula-expression"
                v-on:mouseover="mouseOver"
                v-on:mouseleave="mouseLeave"
                v-on:click="setSelectExpression">
                <template v-if="expressionComponent">
                    <component
                        v-bind="expressionBinder"
                        v-bind:is="expressionComponent"
                        v-bind:expression="expression"
                        v-bind:path="path" />
                </template>
                <template v-else>
                    <div>expressionType: {{ expression.Type }}</div>
                </template>
            </div>
        </pc-interact>
    </div>
</template>
<script>
    import expression from "Formula/Components/expression.vue";

    export default {
        extends: expression,
        props: {
            path: {
                type: Array,
                required: false,
                default: function () {
                    return [];
                }
            }
        },
        data() {
            return {
                hover: false,
                showComponent: true
            };
        },
        computed: {
            hoverPath() {
                return this.$root.hoverPath;
            },
            active() {
                return this.areArraysEqual(this.path, this.$root.selectedObj.path);
            },
            classObject() {
                return {
                    "formula-error": this.expression.inError,
                    draggable: this.hover,
                    "formula-expression-select": this.active
                };
            },
            showClassObj() {
                return {
                    "d-none": !this.showComponent,
                    "d-inline-block": this.showComponent
                };
            }
        },
        methods: {
            mouseOver() {
                if (!this.hoverPath || this.isSubarray(this.path, this.hoverPath)) {
                    this.$root.setHoverPath([...this.path]);
                }
                this.hover = this.areArraysEqual(this.hoverPath, this.path);
            },
            mouseLeave() {
                this.$root.setHoverPath(null);
            },
            areArraysEqual(arr1, arr2) {
                return (
                    arr1 && arr2 && arr1.length === arr2.length && arr1.every((value, index) => value === arr2[index])
                );
            },
            isSubarray(main, sub) {
                if (main.length < sub.length) {
                    return false;
                }
                for (let i = 0; i < sub.length; i++) {
                    if (sub[i] != main[i]) {
                        return false;
                    }
                }
                return true;
            },
            dragMove(event) {
                this.$root.setClonePosition(event);
            },
            dragEnd() {
                this.$root.resetDragObject();
                this.showComponent = true;
            },
            displayClone(event) {
                const rect = this.$refs.expressionWrapper.getBoundingClientRect();
                this.$root.displayChildClone(this.expression, rect, [...this.path], event);
                if (this.formulaControl.inEditMode && this.path.length === 1 && this.path[0] !== 0) {
                    this.showComponent = false;
                }
            },
            setSelectExpression() {
                if (this.formulaControl.inEditMode && this.areArraysEqual(this.hoverPath, this.path)) {
                    this.$root.setSelectExpression(this.expression, this.path);
                    this.hover = false;
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    @use "sass:math";

    @import "Formula/Components/_formula-style-vars.scss";

    .formula-expression {
        border-radius: ($formula-borderRadius) unquote("/") math.div($paren-width, 2);
    }
    .formula-error {
        background-color: rgba(var(--bs-danger-rgb), 0.25);
    }
    .draggable:hover {
        cursor: pointer;
        box-shadow: var(--bs-box-shadow-sm);
        background-color: $draggable-hover-color;
    }
    .formula-expression-select {
        background-color: $select-expression-color;
    }
    %operator-shared {
        margin-left: 0.25rem !important;
        margin-right: 0.25rem !important;
    }
    :deep(.operator) {
        @extend %operator-shared;
        font-size: 1.5rem;
    }
    :deep(.text-operator) {
        @extend %operator-shared;
        font-weight: bold;
    }
</style>
